{
  "brand": {
    "tagline": "A memória da sua casa."
  },
  "common": {
    "loading": "Carregando…",
    "retry": "Tentar de novo",
    "cancel": "Cancelar",
    "close": "Fechar",
    "save": "Salvar alterações",
    "optional": "opcional",
    "or": "ou",
    "you": "você",
    "selected": "selecionado",
    "skipToContent": "Pular para o conteúdo",
    "notifications": "Notificações",
    "edit": "Editar",
    "showMore": "Mostrar mais",
    "pagination": "Paginação",
    "previous": "Anterior",
    "next": "Próxima",
    "pageOf": "Página {{page}} de {{total}}",
    "removedAccount": "Conta removida",
    "back": "Voltar",
    "more": "Mais ações",
    "filters": "Filtros",
    "sort": "Ordenar",
    "add": "Adicionar",
    "search": "Buscar",
    "done": "Concluir",
    "clear": "Limpar"
  },
  "nav": {
    "main": "Navegação principal",
    "home": "Início",
    "house": "Casa",
    "profile": "Menu do perfil",
    "settings": "Configurações",
    "signOut": "Sair",
    "assets": "Equipamentos",
    "requests": "Pedidos",
    "account": "Sua conta"
  },
  "form": {
    "errorSummaryTitle": {
      "one": "Há 1 item para corrigir",
      "other": "Há {{count}} itens para corrigir"
    }
  },
  "errors": {
    "generic": "Algo deu errado do nosso lado. Tente de novo em instantes.",
    "codes": {
      "network_error": "Não conseguimos falar com o Lumora. Confira sua conexão e tente de novo.",
      "server_error": "Algo deu errado do nosso lado. Tente de novo em instantes.",
      "request_failed": "Não foi possível concluir. Tente de novo.",
      "unauthenticated": "Sua sessão terminou. Entre de novo para continuar.",
      "forbidden": "Você não tem permissão para fazer isso.",
      "not_found": "Não encontramos o que você procurava.",
      "conflict": "Isso mudou nesse meio tempo. Recarregue e tente de novo.",
      "version_conflict": "Outra pessoa alterou isso enquanto você editava.",
      "csrf_token_mismatch": "Sua sessão expirou. Recarregue a página e tente de novo.",
      "validation_failed": "Algumas informações precisam da sua atenção.",
      "too_many_requests": "Muitas tentativas. Aguarde {{seconds}} segundos e tente de novo.",
      "too_many_requests_nowait": "Muitas tentativas. Aguarde um instante e tente de novo.",
      "invalid_credentials": "O e-mail ou a senha não estão corretos. Confira e tente de novo.",
      "email_not_verified": "Confirme seu e-mail primeiro. Enviamos um link quando você criou a conta.",
      "email_taken": "Esse e-mail já está em uso por outra conta.",
      "already_member": "Essa pessoa já faz parte da casa.",
      "invitation_pending": "Já existe um convite pendente para esse e-mail.",
      "invitation_expired": "Este convite expirou. Peça um novo.",
      "invitation_used": "Este convite já foi usado.",
      "invitation_revoked": "Este convite foi cancelado.",
      "invitation_email_mismatch": "Este convite foi enviado para outro e-mail.",
      "owner_cannot_be_removed": "O proprietário não pode ser removido. Transfira a propriedade antes.",
      "transfer_pending": "Já existe uma transferência de propriedade aguardando resposta.",
      "last_sign_in_method": "Esta é sua única forma de entrar. Defina uma senha antes de desvincular o Google.",
      "verification_token_invalid": "Este link expirou ou já foi usado.",
      "password_reset_token_invalid": "Este link expirou ou já foi usado. Peça um novo.",
      "idempotency_key_reused": "Esta solicitação já foi enviada com informações diferentes.",
      "file_too_large": "O arquivo é grande demais. Imagens podem ter até 20 MB e PDFs até 25 MB.",
      "household_storage_quota_exceeded": "O espaço de arquivos desta casa acabou. Exclua arquivos que não precisa mais e tente de novo.",
      "unsupported_file_type": "Este tipo de arquivo não é aceito. Use foto (JPEG, PNG, WebP, HEIC) ou PDF.",
      "document_not_ready": "O arquivo ainda está sendo processado. Tente de novo em instantes.",
      "category_exists": "Já existe uma categoria com esse nome.",
      "extraction_quota_exceeded": "Esta casa já usou todas as leituras de documento deste mês. Você pode preencher manualmente.",
      "extraction_disabled": "A leitura de documentos está indisponível no momento. Você pode preencher manualmente.",
      "request_already_selected": "Outra proposta já foi selecionada neste pedido. A página mostra quem foi escolhido.",
      "request_not_open": "Este pedido não está aberto para esta ação.",
      "request_not_editable": "Este pedido não pode mais receber novas informações compartilhadas.",
      "request_not_cancellable": "Este pedido não pode mais ser cancelado.",
      "no_published_revision": "Compartilhe primeiro as informações do pedido, depois convide técnicos.",
      "quote_version_not_current": "Essa proposta foi atualizada nesse meio tempo. Veja a versão mais recente e escolha de novo.",
      "quote_needs_reconfirmation": "As informações do pedido mudaram. O técnico precisa reconfirmar a proposta antes de ela ser escolhida.",
      "quote_expired": "Esta proposta venceu e não pode mais ser escolhida.",
      "quote_withdrawn": "O técnico retirou esta proposta.",
      "quote_already_selected": "Esta proposta já foi selecionada e não pode mais ser retirada.",
      "revision_outdated": "As informações do pedido mudaram. Confira e envie sua proposta de novo.",
      "technician_verification_required": "Confirme seu e-mail para continuar.",
      "technician_verification_required_nohint": "Confirme seu e-mail para continuar.",
      "invitation_bound_to_other_identity": "Este link já está em uso por outra pessoa.",
      "verification_code_invalid": "Esse código não confere. Confira e tente de novo.",
      "verification_code_expired": "Esse código expirou. Peça um novo.",
      "verification_attempts_exceeded": "Muitas tentativas erradas. Peça um novo código.",
      "internal_error": "Algo deu errado do nosso lado. Tente de novo em instantes.",
      "owns_households": "Você ainda administra casas. Transfira ou exclua antes.",
      "export_in_progress": "Já existe uma exportação em preparo.",
      "export_not_ready": "A exportação ainda não está pronta.",
      "export_expired": "Esta exportação expirou. Peça uma nova.",
      "reminder_finished": "Este lembrete já foi concluído.",
      "service_record_pending": "Já existe um registro aguardando confirmação do morador.",
      "technician_not_selected": "Só o prestador escolhido pode registrar o serviço.",
      "request_not_selected": "Este pedido não tem um orçamento escolhido.",
      "service_record_not_correctable": "Este registro não está aguardando correção.",
      "service_record_not_pending": "Este registro não está mais aguardando confirmação."
    },
    "fields": {
      "required": "Preencha este campo.",
      "email": "Informe um e-mail válido.",
      "max": "Use no máximo {{max}} caracteres.",
      "min": "Use pelo menos {{min}} caracteres.",
      "unique": "Este valor já está em uso.",
      "confirmed": "Os dois valores não são iguais.",
      "invalid": "Este valor não é válido.",
      "current_password": "A senha atual não está correta.",
      "in": "Escolha uma das opções disponíveis.",
      "timezone": "Escolha um fuso horário válido.",
      "exists": "Este item não foi encontrado nesta casa.",
      "date": "Informe uma data válida.",
      "integer": "Informe um número inteiro."
    }
  },
  "states": {
    "error": {
      "title": "Não foi possível carregar",
      "description": "Algo deu errado do nosso lado. Tente de novo em instantes.",
      "reference": "Referência",
      "reloadPage": "Recarregar a página"
    },
    "forbidden": {
      "title": "Você não pode ver isto",
      "description": "Você não tem acesso a esta página. Se acha que é um engano, fale com o proprietário da casa."
    },
    "offline": {
      "title": "Você está sem conexão",
      "description": "Reconecte para ver as informações mais recentes. Nada foi salvo enquanto você estava sem conexão.",
      "banner": "Você está sem conexão. As alterações não podem ser salvas até você reconectar."
    },
    "notFound": {
      "title": "Página não encontrada",
      "description": "O link pode estar errado ou esta página não existe mais.",
      "action": "Ir para o início"
    }
  },
  "auth": {
    "fields": {
      "name": "Nome",
      "email": "E-mail",
      "password": "Senha",
      "newPassword": "Nova senha",
      "passwordConfirmation": "Repita a senha",
      "passwordHint": "Use pelo menos {{min}} caracteres."
    },
    "google": {
      "continue": "Continuar com o Google"
    },
    "oauthErrors": {
      "oauth_not_configured": "A entrada com o Google não está disponível agora. Use seu e-mail e senha.",
      "account_exists_link_required": "Já existe uma conta com este e-mail. Entre com sua senha e vincule o Google em Configurações.",
      "oauth_failed": "Não foi possível entrar com o Google. Tente de novo ou use seu e-mail e senha."
    },
    "login": {
      "title": "Entrar",
      "description": "Que bom ver você de novo no Lumora.",
      "submit": "Entrar",
      "remember": "Manter conectado neste dispositivo",
      "forgot": "Esqueceu a senha?",
      "noAccount": "Primeira vez no Lumora?",
      "createAccount": "Criar uma conta"
    },
    "register": {
      "title": "Crie sua conta",
      "description": "Organize as informações da sua casa em um só lugar.",
      "submit": "Criar conta",
      "haveAccount": "Já tem uma conta?",
      "signIn": "Entrar",
      "agree": "Ao criar a conta, você concorda com os Termos de Uso e a Política de Privacidade (links no fim da página)."
    },
    "forgot": {
      "title": "Redefinir a senha",
      "description": "Informe seu e-mail e enviaremos um link para você escolher uma nova senha.",
      "submit": "Enviar link",
      "sentTitle": "Confira seu e-mail",
      "sent": "Se existir uma conta com este e-mail, enviamos um link para redefinir a senha. Pode levar alguns minutos.",
      "back": "Voltar para entrar"
    },
    "reset": {
      "title": "Escolha uma nova senha",
      "description": "Para a conta {{email}}.",
      "submit": "Salvar nova senha",
      "done": "Senha alterada. Entre com a nova senha.",
      "invalidTitle": "Este link não é válido",
      "invalid": "O link expirou, já foi usado ou está incompleto. Peça um novo.",
      "requestNew": "Pedir um novo link"
    }
  },
  "verify": {
    "banner": {
      "badge": "E-mail não confirmado",
      "text": "Confirme {{email}} para convidar pessoas para sua casa. Enviamos um link para você.",
      "resend": "Enviar o link de novo",
      "sent": "Link enviado. Confira sua caixa de entrada."
    },
    "page": {
      "title": "Confirmando seu e-mail",
      "checking": "Verificando seu link…",
      "successTitle": "E-mail confirmado",
      "success": "Obrigado. Seu e-mail foi confirmado.",
      "failedTitle": "Não foi possível confirmar seu e-mail",
      "missing": "Este link está incompleto. Abra o link do e-mail de novo.",
      "expired": "Este link expirou ou já foi usado.",
      "expiredSignedIn": "Você pode pedir um novo link pelo aviso no topo da página.",
      "expiredAnonymous": "Entre na sua conta para pedir um novo link.",
      "continue": "Continuar"
    }
  },
  "household": {
    "switcher": {
      "label": "Trocar de casa",
      "choose": "Escolha uma casa"
    },
    "onboarding": {
      "title": "Crie sua primeira casa",
      "description": "A casa é onde você guarda o que pertence a ela e compartilha com quem mora junto.",
      "action": "Criar uma casa"
    },
    "new": {
      "title": "Nova casa",
      "menu": "Criar uma nova casa",
      "description": "Só o nome é obrigatório. Você completa o resto depois.",
      "submit": "Criar casa",
      "created": "{{name}} foi criada."
    },
    "fields": {
      "name": "Nome da casa",
      "country": "País",
      "countryNone": "Não informar",
      "currency": "Moeda",
      "currencyHint": "Usada como padrão para valores desta casa.",
      "timezone": "Fuso horário",
      "address": "Endereço",
      "addressHint": "Preencha apenas o que faz sentido onde você mora.",
      "line1": "Endereço, linha 1",
      "line2": "Endereço, linha 2",
      "neighborhood": "Bairro",
      "city": "Cidade",
      "region": "Estado, província ou região",
      "postalCode": "Código postal"
    }
  },
  "home": {
    "subtitle": "O que precisa de você nesta casa.",
    "empty": {
      "title": "Nada precisa de você agora",
      "description": "Comece adicionando um equipamento ou pedindo um orçamento.",
      "addAsset": "Adicionar equipamento",
      "askQuote": "Pedir orçamento"
    },
    "pending": {
      "title": "Pendências",
      "needsAction": "Precisa da sua ação",
      "needsAnswer": "Aguardando sua resposta",
      "waiting": "Em andamento"
    },
    "verify": {
      "title": "Confirme seu e-mail",
      "description": "Enviamos um link para {{email}}. Com o e-mail confirmado, você pode convidar pessoas para sua casa."
    },
    "transfer": {
      "title": "{{name}} quer transferir para você a propriedade de {{household}}",
      "consequence": "Se você aceitar, passa a ser o único proprietário e o atual proprietário vira membro.",
      "expires": "Responda até {{date}}.",
      "accept": "Aceitar",
      "decline": "Recusar",
      "accepted": "Agora você é o proprietário.",
      "declined": "Pedido recusado.",
      "confirmTitle": "Tornar-se proprietário de {{household}}?",
      "confirmDescription": "Você passa a gerenciar membros e a propriedade. {{name}} continua na casa como membro."
    },
    "invitations": {
      "title": {
        "one": "1 convite aguardando resposta",
        "other": "{{count}} convites aguardando resposta"
      },
      "description": "As pessoas convidadas ainda não entraram. Você pode cancelar um convite quando quiser.",
      "action": "Ver convites"
    },
    "outgoing": {
      "title": "Aguardando {{name}} aceitar a transferência de propriedade",
      "action": "Ver transferência"
    },
    "quotes": {
      "description_one": "{{count}} orçamento para comparar.",
      "description_other": "{{count}} orçamentos para comparar.",
      "action": "Ver orçamentos"
    },
    "requests": {
      "draft": "Rascunho: falta compartilhar com um técnico.",
      "open": "Aguardando respostas dos técnicos.",
      "action": "Abrir pedido"
    },
    "service": {
      "title": "Serviço em {{asset}} aguarda sua confirmação",
      "noAsset": "um item",
      "by": "Informado por {{name}}",
      "action": "Revisar serviço"
    },
    "reminders": {
      "title": "Lembretes",
      "all": "Ver todos os lembretes",
      "none": "Nenhum lembrete próximo. Ver ou criar lembretes"
    },
    "activity": {
      "title": "Atividade recente",
      "unnamed": "um item removido",
      "generic": "Houve uma atividade na casa.",
      "asset_created": "Equipamento adicionado: {{subject}}",
      "asset_archived": "Equipamento arquivado: {{subject}}",
      "maintenance_created": "Serviço registrado em {{subject}}",
      "maintenance_updated": "Registro de serviço corrigido em {{subject}}",
      "service_record_proposed": "O prestador informou um serviço em {{subject}}",
      "service_record_corrected": "O prestador corrigiu o serviço em {{subject}}",
      "service_record_correction_requested": "Correção pedida ao prestador em {{subject}}",
      "service_record_confirmed": "Serviço confirmado em {{subject}}",
      "request_created": "Pedido criado: {{subject}}",
      "request_quote_selected": "Orçamento escolhido no pedido {{subject}}",
      "request_cancelled": "Pedido cancelado: {{subject}}",
      "request_completed": "Pedido concluído: {{subject}}",
      "quote_submitted": "Orçamento recebido no pedido {{subject}}",
      "quote_resubmitted": "Orçamento atualizado no pedido {{subject}}",
      "reminder_completed": "Lembrete marcado como feito: {{subject}}",
      "invitation_accepted": "Um novo membro entrou na casa"
    },
    "greeting": "Olá, {{name}}"
  },
  "house": {
    "title": "Casa",
    "roles": {
      "owner": "Proprietário",
      "member": "Membro"
    },
    "settings": {
      "title": "Dados da casa",
      "descriptionOwner": "Você pode alterar estes dados porque é o proprietário.",
      "descriptionMember": "Só o proprietário pode alterar estes dados.",
      "saved": "Alterações salvas.",
      "conflictTitle": "Alguém alterou esta casa enquanto você editava",
      "conflictDescription": "Suas alterações continuam aqui e não foram salvas. Carregue a versão mais recente ou mantenha suas alterações e salve por cima.",
      "conflictReload": "Carregar a versão mais recente",
      "conflictKeep": "Manter minhas alterações e salvar"
    },
    "members": {
      "title": "Membros",
      "descriptionOwner": "Pessoas com acesso a esta casa. Remover alguém encerra o acesso imediatamente.",
      "descriptionMember": "Pessoas com acesso a esta casa.",
      "joined": "Entrou em {{date}}",
      "remove": "Remover",
      "removeTitle": "Remover {{name}}?",
      "removeDescription": "{{name}} perde o acesso a esta casa imediatamente. Você pode convidar a pessoa de novo depois.",
      "removeConfirm": "Remover acesso",
      "removed": "{{name}} foi removido(a)."
    },
    "invite": {
      "title": "Convidar alguém",
      "description": "Enviamos o convite por e-mail. Ele vale para um uso e expira em 7 dias.",
      "hint": "A pessoa precisa usar este mesmo e-mail para entrar.",
      "submit": "Enviar convite",
      "sent": "Convite enviado para {{email}}.",
      "pendingTitle": "Convites aguardando resposta",
      "none": "Nenhum convite pendente.",
      "expires": "Expira em {{date}}",
      "status": {
        "pending": "Aguardando"
      },
      "revoke": "Cancelar convite",
      "revokeTitle": "Cancelar este convite?",
      "revokeDescription": "O link enviado para {{email}} deixa de funcionar na hora.",
      "revokeConfirm": "Cancelar convite",
      "revoked": "Convite cancelado."
    },
    "ownership": {
      "title": "Propriedade",
      "description": "Transfira a propriedade desta casa para outro membro. Nada muda até a pessoa aceitar.",
      "start": "Transferir propriedade",
      "sheetTitle": "Transferir propriedade",
      "consequence": "Se o membro aceitar, ele passa a ser o único proprietário e você vira membro. Você mantém o acesso, mas não gerencia mais membros nem a propriedade.",
      "chooseMember": "Novo proprietário",
      "send": "Enviar pedido",
      "started": "Pedido enviado. Nada muda até ele ser aceito.",
      "waiting": "Aguardando resposta",
      "pending": "{{name}} tem até {{date}} para aceitar a transferência.",
      "cancel": "Cancelar pedido",
      "cancelled": "Pedido cancelado.",
      "noCandidates": "Para transferir a propriedade, convide outra pessoa primeiro e aguarde ela entrar."
    },
    "leave": {
      "title": "Sair desta casa",
      "description": "Se você sair de {{name}}, perde o acesso a ela.",
      "action": "Sair da casa",
      "confirmTitle": "Sair de {{name}}?",
      "confirmDescription": "Seu acesso termina imediatamente. Para voltar, o proprietário precisa convidar você de novo.",
      "confirm": "Sair da casa",
      "done": "Você saiu de {{name}}."
    },
    "documents": {
      "title": "Documentos",
      "description": "Notas, manuais e garantias da casa.",
      "open": "Abrir documentos"
    },
    "delete": {
      "zone": "Zona de perigo",
      "description": "Excluir a casa encerra o acesso de todos imediatamente. Faça antes uma exportação se quiser guardar os dados.",
      "open": "Excluir esta casa",
      "confirmTitle": "Excluir {{name}}?",
      "consequences": "Esta ação não pode ser desfeita.",
      "points": {
        "access": "Todos perdem o acesso agora: membros e técnicos com links, sem exceção.",
        "purge": "Os dados e arquivos são apagados definitivamente em até 30 dias.",
        "backups": "Cópias de segurança expiram conforme a retenção e não são restauradas com acesso.",
        "export": "Se precisar dos dados, exporte antes."
      },
      "typeName": "Digite o nome da casa para confirmar: {{name}}",
      "password": "Sua senha",
      "action": "Excluir casa",
      "done": "A casa foi excluída."
    },
    "export": {
      "cardTitle": "Exportar dados",
      "cardDescription": "Baixe uma cópia dos dados e arquivos da casa.",
      "open": "Exportar",
      "crumb": "Exportação",
      "title": "Exportar dados da casa",
      "intro": "Gere uma cópia para guardar ou levar com você. Só o owner pode exportar.",
      "includedTitle": "O que entra",
      "included": "Equipamentos, serviços, pedidos, orçamentos, lembretes e membros em JSON e CSV, mais os arquivos prontos, num ZIP.",
      "excludedTitle": "O que não entra",
      "excluded": "Senhas, tokens, segredos e dados de outras casas nunca são exportados.",
      "availability": "A exportação fica disponível para download por 24 horas e depois é apagada.",
      "requestTitle": "Sua exportação",
      "none": "Você ainda não pediu nenhuma exportação.",
      "request": "Pedir exportação",
      "again": "Pedir nova exportação",
      "inProgress": "Já existe uma exportação em preparo. Acompanhe por aqui.",
      "ownerOnly": "Só o owner da casa pode exportar os dados.",
      "status": {
        "queued": "Na fila",
        "processing": "Preparando",
        "ready": "Pronta para baixar",
        "failed": "Não deu certo",
        "expired": "Expirada"
      },
      "requestedAt": "Pedida em {{date}}",
      "preparing": "Estamos preparando o arquivo. Esta página se atualiza sozinha.",
      "expiresAt": "Disponível até {{date}}",
      "download": "Baixar ZIP",
      "failedNote": "A exportação falhou. Você pode pedir de novo.",
      "expiredNote": "O prazo de 24 horas acabou e o arquivo foi apagado. Peça uma nova."
    }
  },
  "invite": {
    "title": "Você foi convidado para uma casa",
    "description": "{{inviter}} convidou você para fazer parte de {{household}} no Lumora.",
    "household": "Casa",
    "invitedBy": "Convidado por",
    "forAddress": "Enviado para",
    "expires": "Válido até",
    "signedInAs": "Você está conectado como {{email}}.",
    "signInPrompt": "Entre ou crie uma conta com o e-mail convidado para aceitar.",
    "signIn": "Entrar",
    "createAccount": "Criar uma conta",
    "accept": "Aceitar convite",
    "joined": "Você entrou em {{name}}.",
    "useOtherAccount": "Sair e usar outra conta",
    "goHome": "Ir para o início",
    "unavailableTitle": "Este convite não está disponível",
    "errors": {
      "invitation_not_found": "Não encontramos este convite. Confira o link do seu e-mail.",
      "invitation_expired": "Este convite expirou. Peça um novo ao proprietário da casa.",
      "invitation_used": "Este convite já foi usado.",
      "invitation_revoked": "O proprietário cancelou este convite.",
      "invitation_email_mismatch": "Este convite foi enviado para {{hint}}, mas você está conectado como {{email}}. Saia e use o e-mail convidado.",
      "already_member": "Você já faz parte desta casa."
    }
  },
  "settings": {
    "title": "Configurações",
    "saved": "Salvo.",
    "notSynced": "Sua escolha vale neste dispositivo, mas não conseguimos salvá-la no seu perfil.",
    "profile": {
      "title": "Perfil"
    },
    "email": {
      "title": "E-mail",
      "verified": "Confirmado",
      "unverified": "Não confirmado",
      "pending": "Aguardando você confirmar {{email}}. Seu e-mail só muda quando você abrir o link que enviamos para lá.",
      "description": "Para trocar o e-mail, informe sua senha atual. Enviamos um link para o novo endereço.",
      "newEmail": "Novo e-mail",
      "submit": "Trocar e-mail",
      "sent": "Enviamos um link para {{email}}. Seu e-mail muda depois que você confirmar.",
      "needPassword": "Defina uma senha abaixo para poder trocar o e-mail."
    },
    "appearance": {
      "title": "Idioma e aparência"
    },
    "language": {
      "label": "Idioma"
    },
    "theme": {
      "label": "Tema",
      "light": "Claro",
      "dark": "Escuro",
      "system": "Igual ao dispositivo"
    },
    "password": {
      "title": "Senha",
      "description": "Ao trocar a senha, suas outras sessões são encerradas.",
      "setTitle": "Defina uma senha",
      "setDescription": "Sua conta ainda não tem senha. Com uma senha, você também pode entrar com e-mail.",
      "current": "Senha atual",
      "submit": "Trocar senha",
      "setSubmit": "Definir senha",
      "changed": "Senha salva."
    },
    "oauth": {
      "title": "Formas de entrar",
      "description": "Você pode manter sua conta do Google vinculada para entrar mais rápido.",
      "link": "Vincular conta do Google",
      "linked": "Google vinculado",
      "unlink": "Desvincular Google",
      "unlinkTitle": "Desvincular o Google?",
      "unlinkDescription": "Você não poderá mais entrar com o Google. Confirme que consegue entrar por outra forma.",
      "unlinked": "Google desvinculado.",
      "notice": {
        "signed_in": "Você entrou com o Google.",
        "linked": "Sua conta do Google foi vinculada."
      }
    },
    "session": {
      "title": "Sessão"
    },
    "confirmEmail": {
      "title": "Confirmando seu novo e-mail",
      "successTitle": "E-mail alterado",
      "success": "Seu e-mail agora é {{email}}.",
      "failedTitle": "Não foi possível trocar seu e-mail",
      "back": "Voltar para configurações"
    },
    "delete": {
      "title": "Excluir conta",
      "description": "Encerra sua conta e remove você das casas. Casas que você administra precisam ser transferidas ou excluídas antes.",
      "open": "Excluir minha conta",
      "confirmTitle": "Excluir sua conta?",
      "consequences": "Você sai de todas as casas e perde o acesso. Seu nome é removido do histórico que outros membros mantêm: aparece como “Conta removida”. Não dá para desfazer.",
      "password": "Sua senha",
      "typeEmail": "Digite seu e-mail para confirmar: {{email}}",
      "action": "Excluir conta",
      "ownsTitle": "Você ainda administra casas",
      "ownsBody": "Transfira a propriedade ou exclua estas casas e tente de novo:",
      "ownsUnnamed": "Abrir casa",
      "goodbyeTitle": "Sua conta foi excluída",
      "goodbyeBody": "Obrigado por usar o Lumora. Seus dados pessoais foram removidos e você saiu de todas as casas.",
      "goodbyeAction": "Ir para o login"
    },
    "legal": {
      "title": "Sobre",
      "privacy": "Política de Privacidade",
      "terms": "Termos de Uso"
    }
  },
  "catalog": {
    "title": "Catálogo de componentes",
    "width": "Largura do quadro",
    "syntheticNote": "Apenas exemplos sintéticos. Sem dados reais.",
    "sections": {
      "buttons": "Botões",
      "fields": "Campos",
      "status": "Status",
      "overlays": "Diálogos e menus",
      "layout": "Layout",
      "states": "Estados de página",
      "assets": "Itens da casa",
      "history": "Histórico de serviços",
      "extraction": "Revisão de leitura",
      "upload": "Envio de arquivo",
      "warranty": "Garantia",
      "requests": "Compartilhamento e propostas",
      "technician": "Técnico",
      "m4": "Lembretes, avisos e confirmações",
      "mobile": "Padrões de app (celular)"
    }
  },
  "money": {
    "hint": "Digite como de costume. Exemplo: {{example}}",
    "currency": "Moeda",
    "errors": {
      "invalid": "Valor não reconhecido. Use apenas números, com o separador do seu idioma para os centavos.",
      "too_many_decimals": "Esta moeda aceita menos casas decimais. Corrija o valor; não arredondamos por você.",
      "too_large": "Este valor é grande demais.",
      "negative": "O valor não pode ser negativo."
    }
  },
  "warranty": {
    "valid": "Garantia válida",
    "expiring_one": "Garantia termina em {{count}} dia",
    "expiring_other": "Garantia termina em {{count}} dias",
    "endsToday": "Garantia termina hoje",
    "expired": "Garantia vencida",
    "notInformed": "Garantia não informada"
  },
  "history": {
    "by": {
      "you": "Registrado por você",
      "name": "Registrado por {{name}}",
      "resident": "Registrado por um morador",
      "technician": "Informado pelo prestador",
      "removed": "Registrado por uma conta removida"
    },
    "edited": "Editado",
    "status": {
      "pending_confirmation": "Aguardando confirmação",
      "correction_requested": "Correção solicitada",
      "confirmed": "Confirmado pelo morador"
    },
    "receipts": "Comprovantes",
    "recordedAt": "Registrado em {{date}}",
    "details": "Ver detalhes"
  },
  "assets": {
    "title": "Equipamentos e áreas",
    "subtitle": "Tudo o que você quer lembrar sobre a sua casa, num só lugar.",
    "add": "Adicionar equipamento",
    "fromPhoto": "Adicionar a partir de foto ou nota",
    "fromPhotoCrumb": "A partir de foto ou nota",
    "archivedBadge": "Arquivado",
    "kind": {
      "equipment": "Equipamento",
      "area": "Área"
    },
    "kindHelp": {
      "equipment": "Um aparelho ou item, como geladeira ou bomba.",
      "area": "Um espaço da casa, como telhado ou jardim."
    },
    "count_one": "{{formatted}} item",
    "count_other": "{{formatted}} itens",
    "search": {
      "label": "Buscar",
      "placeholder": "Nome, marca, modelo ou ambiente"
    },
    "sort": {
      "label": "Ordenar por",
      "name": "Nome (A–Z)",
      "-name": "Nome (Z–A)",
      "-updated_at": "Atualizados recentemente",
      "updated_at": "Atualizados há mais tempo"
    },
    "filters": {
      "title": "Filtros",
      "kind": "Tipo",
      "kindAll": "Equipamentos e áreas",
      "category": "Categoria",
      "categoryAll": "Todas as categorias",
      "room": "Ambiente",
      "roomAll": "Todos os ambientes",
      "archived": "Mostrar só os arquivados",
      "all": "Todos",
      "equipment": "Equipamentos",
      "areas": "Áreas"
    },
    "empty": {
      "title": "Nada cadastrado ainda",
      "description": "Cadastre um equipamento e guarde marca, modelo, garantia, fotos e serviços num só lugar. Dá para começar só com o nome."
    },
    "noResults": {
      "title": "Nenhum resultado",
      "description": "Nada corresponde a esta busca ou a estes filtros.",
      "clear": "Limpar busca e filtros"
    },
    "categories": {
      "refrigerator": "Geladeira ou freezer",
      "washer": "Máquina de lavar",
      "dryer": "Secadora ou lava e seca",
      "dishwasher": "Lava-louças",
      "cooking": "Fogão, cooktop ou forno",
      "microwave": "Micro-ondas",
      "hvac": "Climatização e ventilação",
      "electronics": "TV, áudio e eletrônicos",
      "water_heater": "Aquecedores",
      "filters": "Filtros e purificadores",
      "pumps": "Bombas",
      "garden_pool": "Jardim e piscina",
      "small_appliances": "Pequenos eletrodomésticos",
      "electrical": "Elétrica",
      "plumbing": "Hidráulica",
      "roof": "Telhado",
      "other": "Outros"
    },
    "fields": {
      "name": "Nome",
      "category": "Categoria",
      "categoryNone": "Sem categoria",
      "categoryNew": "Criar nova categoria…",
      "categoryName": "Nome da nova categoria",
      "categoryCreate": "Criar categoria",
      "room": "Ambiente",
      "roomHint": "Escreva livremente, por exemplo “Cozinha”. Sugerimos os que você já usou.",
      "brand": "Marca",
      "model": "Modelo",
      "serial": "Número de série",
      "purchaseDate": "Data da compra",
      "price": "Valor pago",
      "seller": "Vendedor ou loja",
      "warrantyUntil": "Fim da garantia",
      "warrantyHint": "Informe só se você souber. Não calculamos a garantia por você.",
      "warrantyReminder": "Quero um aviso 30 dias antes do fim",
      "notes": "Observações"
    },
    "form": {
      "newTitle": "Novo equipamento ou área",
      "editTitle": "Editar",
      "newCrumb": "Novo",
      "editCrumb": "Editar",
      "newIntro": "Só o nome é obrigatório. O resto você completa quando quiser.",
      "fromPhotoLink": "Prefere começar por uma foto da etiqueta ou da nota fiscal?",
      "identification": "Identificação",
      "kind": "O que é?",
      "product": "Produto",
      "purchase": "Compra e garantia",
      "notes": "Anotações",
      "photo": "Foto",
      "photoHint": "Ajuda a reconhecer o item. Não é obrigatória.",
      "photoUploadHint": "Envie uma foto do equipamento ou da área.",
      "removePhoto": "Remover foto",
      "attachedFile": "Arquivo que será guardado com o item: {{name}}",
      "useAsCover": "Usar esta foto como foto do equipamento",
      "waitUpload": "Aguarde o envio do arquivo terminar para salvar.",
      "create": "Criar",
      "created": "Equipamento criado.",
      "createdNoFile": "Criado, mas não foi possível anexar o arquivo. Envie de novo na página do item.",
      "saved": "Alterações salvas.",
      "conflictTitle": "Alguém alterou isto enquanto você editava",
      "conflictDescription": "Suas alterações continuam aqui e não foram salvas. Carregue a versão mais recente ou mantenha suas alterações e salve por cima.",
      "conflictReload": "Carregar a versão mais recente",
      "conflictKeep": "Manter minhas alterações e salvar"
    },
    "detail": {
      "history": "Histórico de serviços",
      "historyEmpty": {
        "title": "Nenhum serviço registrado",
        "description": "Registre manutenções e consertos para saber depois o que foi feito, quando e por quem."
      },
      "documents": "Documentos",
      "documentsEmpty": "Nenhum documento ligado a este item.",
      "addDocument": "Enviar mais um documento",
      "unlink": "Desvincular",
      "unlinkTitle": "Desvincular este documento?",
      "unlinkDescription": "Ele deixa de aparecer neste item, mas continua guardado nos documentos da casa.",
      "identification": "Identificação",
      "identificationEmpty": "Ainda não há marca, modelo ou número de série. Você pode completar quando quiser.",
      "warranty": "Garantia",
      "warrantyUntil": "Até {{date}}, conforme informado por você",
      "warrantyNote": "Só mostramos a garantia que você informar.",
      "notes": "Observações",
      "enlarge": "Ampliar foto",
      "enlargeShort": "Ampliar",
      "photoAlt": "Foto de {{name}}",
      "copy": "Copiar",
      "copiedShort": "Copiado",
      "copySerial": "Copiar número de série",
      "copied": "Número de série copiado.",
      "copyFailed": "Não foi possível copiar. Selecione o texto e copie manualmente.",
      "readDocument": "Ler etiqueta ou nota",
      "archivedNote": "Este item está arquivado. O histórico e os documentos continuam guardados.",
      "archiveTitle": "Arquivar",
      "archiveDescription": "Arquivar tira o item da lista principal. O histórico de serviços e os documentos são preservados e você pode restaurá-lo depois.",
      "archive": "Arquivar",
      "archived": "Item arquivado.",
      "archiveConfirmTitle": "Arquivar “{{name}}”?",
      "archiveConfirmDescription": "O item sai da lista principal, mas o histórico de serviços e os documentos continuam guardados. Você pode restaurá-lo quando quiser.",
      "restoreTitle": "Restaurar",
      "restoreDescription": "Traz o item de volta para a lista principal.",
      "restore": "Restaurar",
      "restored": "Item restaurado.",
      "reminders": "Lembretes",
      "remindersAll": "Ver todos",
      "remindersNew": "Novo lembrete",
      "remindersEmpty": "Nenhum lembrete ativo para este item.",
      "addPhoto": "Adicionar foto",
      "changePhoto": "Trocar foto",
      "photoSaved": "Foto do equipamento atualizada"
    }
  },
  "services": {
    "register": "Registrar serviço",
    "intro": "Anote o que foi feito, mesmo sem ter pedido orçamento aqui.",
    "editTitle": "Corrigir registro",
    "editIntro": "Ao salvar, guardamos a versão anterior. O registro aparecerá como editado.",
    "detailCrumb": "Serviço",
    "save": "Salvar serviço",
    "saved": "Serviço registrado.",
    "updated": "Registro corrigido.",
    "conflict": "Este registro foi alterado por outra pessoa. Suas alterações continuam aqui e não foram salvas.",
    "readOnlyTechnician": "Este registro foi informado pelo prestador e não pode ser editado por aqui.",
    "fields": {
      "asset": "Equipamento ou área",
      "assetChoose": "Escolha um item",
      "date": "Data do serviço",
      "description": "O que foi feito",
      "descriptionHint": "Por exemplo: troca do filtro e limpeza geral.",
      "provider": "Prestador",
      "parts": "Peças",
      "cost": "Valor pago",
      "warrantyUntil": "Garantia do serviço até",
      "warrantyHint": "Informe só se o prestador deu uma garantia.",
      "warrantyNotes": "Condições da garantia"
    },
    "documents": {
      "title": "Comprovantes",
      "hint": "Anexe notas, recibos ou fotos. Até {{max}} arquivos.",
      "pick": "Escolher entre os documentos da casa",
      "remove": "Remover {{name}}",
      "full": "Limite de {{max}} arquivos atingido.",
      "none": "Nenhum comprovante anexado."
    },
    "pick": {
      "title": "Documentos da casa",
      "description": "Marque os que quer anexar. Ainda cabem {{count}}.",
      "none": "Não há outros documentos prontos para anexar.",
      "add_one": "Anexar {{count}} documento",
      "add_other": "Anexar {{count}} documentos"
    },
    "revisions": {
      "title": "Correções",
      "description": "Cada edição guarda a versão anterior, para você saber o que mudou.",
      "show_one": "Ver a versão anterior",
      "show_other": "Ver as {{count}} versões anteriores",
      "entry": "Versão {{version}} · substituída em {{when}} por {{name}}",
      "previous": "Valores anteriores",
      "unknown": "alguém da casa"
    },
    "review": {
      "title": "Serviço informado pelo prestador",
      "confirm": "Confirmar serviço",
      "askCorrection": "Pedir correção",
      "confirmTitle": "Confirmar este serviço?",
      "confirmBody": "Ao confirmar, o serviço entra no histórico do item e o pedido fica concluído.",
      "notCertification": "A confirmação é sua, do morador: não é uma certificação técnica independente do serviço.",
      "confirmAction": "Confirmar serviço",
      "confirmed": "Serviço confirmado. O pedido está concluído.",
      "correctionTitle": "Pedir correção ao prestador",
      "correctionBody": "O prestador verá o motivo e poderá reenviar o registro.",
      "reason": "O que precisa ser corrigido?",
      "correctionAction": "Enviar pedido de correção",
      "correctionSent": "Pedido de correção enviado.",
      "waitingCorrection": "Aguardando correção do prestador",
      "yourReason": "Motivo informado: {{reason}}",
      "stale": "Este registro mudou enquanto você olhava. Atualizamos a tela: confira e tente de novo.",
      "noneYet": "O prestador ainda não informou o serviço realizado.",
      "completedTitle": "Pedido concluído",
      "completedBody": "O serviço foi confirmado por você e está no histórico do item.",
      "seeHistory": "Ver histórico do item",
      "confirmedBy": "Confirmado pelo morador {{name}} em {{date}}."
    }
  },
  "documents": {
    "kinds": {
      "photo": "Foto",
      "label": "Foto da etiqueta",
      "invoice": "Nota fiscal",
      "receipt": "Recibo ou comprovante",
      "manual": "Manual",
      "warranty": "Termo de garantia",
      "other": "Outro"
    },
    "status": {
      "ready": "Pronto",
      "processing": "Processando",
      "rejected": "Recusado"
    },
    "notReadyYet": "Enviado, mas ainda não está pronto. Só dá para abrir quando terminar de processar.",
    "rejection": {
      "unsupported_file_type": "O conteúdo do arquivo não é de um tipo aceito. Use foto (JPEG, PNG, WebP, HEIC) ou PDF.",
      "file_too_large": "O arquivo é grande demais.",
      "corrupted_file": "Não conseguimos abrir o arquivo. Ele pode estar danificado.",
      "encrypted_pdf": "Este PDF tem senha. Envie uma versão sem senha.",
      "too_many_pages": "Este PDF tem páginas demais. Envie só as páginas necessárias.",
      "processing_failed": "Não foi possível processar o arquivo. Tente enviar de novo."
    },
    "pages_one": "{{count}} página",
    "pages_other": "{{count}} páginas",
    "uploadedBy": "enviado por {{name}}",
    "open": "Abrir",
    "opensInNewTab": "(abre em outra aba)",
    "download": "Baixar",
    "added": "Documento adicionado.",
    "untitled": "Documento sem nome",
    "upload": {
      "choose": "Escolher arquivo",
      "chooseAnother": "Escolher outro arquivo",
      "camera": "Tirar foto",
      "hint": "Foto (JPEG, PNG, WebP, HEIC) ou PDF. Até 20 MB para imagens e 25 MB para PDF.",
      "kindLabel": "Tipo de documento",
      "uploading": "Enviando arquivo",
      "uploadingProgress": "Enviando… {{percent}}%",
      "processing": "Processando o arquivo…",
      "processingExplain": "O arquivo foi enviado, mas só poderá ser usado quando estiver pronto.",
      "processingSlow": "Está demorando mais que o normal. Você pode continuar aqui ou voltar depois; o arquivo segue sendo processado.",
      "another": "Enviar outro arquivo",
      "rejectedTitle": "Este arquivo não pôde ser usado",
      "errorTitle": "Não foi possível enviar",
      "sensitiveNote": "Etiquetas, notas e recibos podem mostrar número de série, nome ou endereço. O arquivo fica privado na sua casa e você pode removê-lo quando quiser.",
      "client": {
        "unsupported_file_type": "Este tipo de arquivo não é aceito. Use foto (JPEG, PNG, WebP, HEIC) ou PDF.",
        "file_too_large": "O arquivo é grande demais. Imagens podem ter até 20 MB e PDFs até 25 MB.",
        "empty_file": "O arquivo está vazio."
      }
    },
    "library": {
      "title": "Documentos da casa",
      "subtitle": "Notas, manuais, garantias e fotos guardados com privacidade.",
      "add": "Adicionar documento",
      "search": "Buscar por nome",
      "allKinds": "Todos os tipos",
      "asset": "Equipamento ou área",
      "allAssets": "Todos",
      "selectedAsset": "Item selecionado",
      "sortNewest": "Mais recentes",
      "sortOldest": "Mais antigos",
      "sortTitle": "Nome (A–Z)",
      "noResults": "Nenhum documento encontrado",
      "emptyTitle": "Nenhum documento ainda",
      "emptyDescription": "Guarde aqui notas fiscais, manuais e garantias para encontrá-los quando precisar.",
      "count_one": "{{formatted}} documento",
      "count_other": "{{formatted}} documentos"
    },
    "edit": {
      "action": "Renomear ou reclassificar",
      "title": "Renomear ou reclassificar",
      "description": "Só muda o nome e o tipo; o arquivo não é alterado.",
      "name": "Nome",
      "originalName": "Arquivo original: {{name}}",
      "saved": "Documento atualizado.",
      "conflict": "Outra pessoa alterou este documento. Feche e abra de novo para ver a versão mais recente."
    },
    "delete": {
      "action": "Excluir",
      "title": "Excluir este documento?",
      "description": "O acesso ao arquivo termina agora, para todos da casa, e ele deixa de aparecer nos itens. O arquivo é removido do armazenamento um pouco depois.",
      "confirm": "Excluir documento",
      "done": "Documento excluído."
    }
  },
  "extraction": {
    "titleCreate": "Adicionar a partir de foto ou nota",
    "titleUpdate": "Ler etiqueta ou nota",
    "introCreate": "Envie a foto da etiqueta, do próprio equipamento ou a nota fiscal. Vamos sugerir os dados e você decide o que aceitar.",
    "introUpdate": "Envie ou escolha um arquivo. As sugestões só mudam o item se você aceitar.",
    "whatIs": "O que você vai enviar?",
    "task": {
      "label": "Foto da etiqueta",
      "receipt": "Nota fiscal ou recibo",
      "item": "Foto do equipamento"
    },
    "taskHelp": {
      "label": "A etiqueta com marca, modelo e número de série.",
      "receipt": "Mostra loja, data e valor da compra.",
      "item": "Sem etiqueta ou difícil de alcançar? Tentamos reconhecer o que é e a marca, se aparecer."
    },
    "nameOptional": "Nome do equipamento",
    "nameOptionalHint": "Se já souber. Guardamos para o caso de a leitura não funcionar.",
    "uploadHint": "Foto (JPEG, PNG, WebP, HEIC) ou PDF.",
    "useExisting": "Ou use um arquivo que já está neste item",
    "useThis": "Usar este",
    "manualInstead": "Prefiro preencher manualmente",
    "backToAsset": "Voltar ao item",
    "consentTitle": "Antes de ler o documento",
    "consent": "Somente este arquivo será enviado ao {{provider}} para leitura.",
    "consentFine": "Nenhuma outra informação da sua casa é enviada. Nada é alterado sem a sua aceitação.",
    "quota": "Você usou {{used}} de {{limit}} leituras neste mês.",
    "allow": "Permitir e ler o documento",
    "fillManually": "Preencher manualmente",
    "quotaReachedTitle": "Leituras do mês esgotadas",
    "quotaReached": "Esta casa já usou as {{limit}} leituras deste mês.",
    "disabledTitle": "Leitura indisponível",
    "disabled": "A leitura de documentos está desligada no momento.",
    "manualStillWorks": "O arquivo foi guardado e o cadastro manual continua funcionando.",
    "reading": "Lendo o documento…",
    "readingHint": "Pode levar alguns segundos.",
    "failedTitle": "Não foi possível ler o documento",
    "failedKept": "O arquivo foi guardado. Você pode continuar preenchendo manualmente.",
    "errors": {
      "provider_unavailable": "O serviço de leitura está indisponível agora.",
      "provider_timeout": "A leitura demorou demais e foi interrompida.",
      "invalid_provider_output": "Não conseguimos entender o resultado da leitura.",
      "unsupported_document": "Este tipo de documento não pode ser lido.",
      "document_too_large": "O documento é grande demais para ser lido.",
      "timeout": "A leitura está demorando mais que o normal.",
      "generic": "Não foi possível ler o documento agora."
    },
    "review": {
      "intro": "Estas são sugestões. Nada é aplicado até você aceitar, campo a campo, e você pode editar antes.",
      "current": "Valor atual",
      "empty": "Em branco",
      "suggestion": "Sugestão",
      "accept": "Usar este valor",
      "accepted": "Valor aceito",
      "nameHint": "Obrigatório. Escolha uma sugestão ou escreva o seu.",
      "nameSuggestions": "Sugestões de nome:",
      "read": "Lido no documento: {{value}}",
      "readRaw": "Lido no documento: {{amount}} {{currency}}. Confirme o valor abaixo."
    },
    "notFound": {
      "name": "Não identificamos um nome. Você pode preencher agora ou depois.",
      "category": "Não identificamos a categoria. Você pode escolher agora ou depois.",
      "brand": "Não identificamos a marca. Você pode preencher agora ou depois.",
      "model": "Não identificamos o modelo. Você pode preencher agora ou depois.",
      "serial_number": "Não identificamos o número de série. Você pode preencher agora ou depois.",
      "seller": "Não identificamos a loja. Você pode preencher agora ou depois.",
      "purchase_date": "Não identificamos a data da compra. Você pode preencher agora ou depois.",
      "price": "Não identificamos o valor. Você pode preencher agora ou depois."
    },
    "createWith": "Criar equipamento com o que aceitei",
    "applyAccepted": "Aplicar o que aceitei",
    "updated": "Item atualizado.",
    "conflict": "Este item foi alterado por outra pessoa. Recarregue os dados atuais e confirme de novo.",
    "conflictReload": "Recarregar dados atuais"
  },
  "requests": {
    "title": "Pedidos",
    "subtitle": "Peça orçamentos a técnicos e compare as respostas.",
    "ask": "Pedir orçamento",
    "noItem": "Sem item vinculado",
    "unpublished": "Há alterações não compartilhadas",
    "unpublishedShort": "Não compartilhado",
    "updatedAt": "Atualizado em {{date}}",
    "count_one": "{{formatted}} pedido",
    "count_other": "{{formatted}} pedidos",
    "counts": {
      "invitations_one": "{{count}} técnico convidado",
      "invitations_other": "{{count}} técnicos convidados",
      "quotes_one": "{{count}} proposta",
      "quotes_other": "{{count}} propostas"
    },
    "status": {
      "draft": "Rascunho",
      "open": "Aguardando resposta",
      "selected": "Selecionado",
      "completed": "Concluído",
      "cancelled": "Cancelado"
    },
    "filters": {
      "status": "Situação",
      "statusAll": "Todas as situações",
      "asset": "Equipamento ou área",
      "assetAll": "Todos os itens",
      "sort": "Ordenar por"
    },
    "sort": {
      "-updated_at": "Atualizados recentemente",
      "-created_at": "Mais novos primeiro",
      "created_at": "Mais antigos primeiro"
    },
    "empty": {
      "title": "Nenhum pedido ainda",
      "description": "Comece um pedido quando algo precisar de um técnico. Você escolhe o que compartilhar e cada técnico recebe o próprio link."
    },
    "noResults": {
      "title": "Nenhum pedido com esses filtros",
      "description": "Tente outra situação ou outro item.",
      "clear": "Limpar filtros"
    },
    "fields": {
      "title": "Do que você precisa?",
      "titleHint": "Um título curto, por exemplo “Geladeira não gela”.",
      "description": "Descrição",
      "symptoms": "O que está acontecendo",
      "symptomsHint": "Ruídos, códigos de erro, desde quando acontece.",
      "availability": "Quando alguém pode visitar?",
      "availabilityHint": "Texto livre, por exemplo “manhãs em dias úteis”. O Lumora não agenda visitas.",
      "neighborhood": "Bairro",
      "city": "Cidade",
      "locationHint": "Opcional. Só é compartilhado se você escolher. O endereço completo nunca é compartilhado.",
      "currency": "Moeda das propostas",
      "currencyHint": "Os técnicos orçam nesta moeda.",
      "currencyLocked": "A moeda não pode mudar depois que o pedido é compartilhado."
    },
    "new": {
      "title": "Novo pedido",
      "intro": "Três passos curtos: o item, o problema e o que o técnico verá.",
      "fromIntro": "Confira as informações copiadas do pedido anterior e escolha o que compartilhar.",
      "steps": "Passos",
      "step": {
        "item": "Item",
        "problem": "Problema",
        "share": "Compartilhar"
      },
      "next": "Continuar",
      "nextShare": "Continuar para compartilhar",
      "back": "Voltar",
      "item": {
        "title": "Qual item precisa de ajuda?",
        "hint": "Você também pode começar sem item e vincular depois.",
        "mode": {
          "existing": "Um item que já cadastrei",
          "new": "Cadastrar um item novo agora",
          "none": "Ainda não tenho um item"
        },
        "modeHint": {
          "existing": "Escolha entre seus equipamentos e áreas.",
          "new": "Bastam poucas informações.",
          "none": "Você pode descrever o problema sem vincular um item."
        },
        "pick": "Equipamento ou área",
        "pickChoose": "Escolha…",
        "newHint": "Vamos cadastrá-lo na sua casa para que fique guardado."
      },
      "problem": {
        "title": "Descreva o problema",
        "noItem": "Nenhum item vinculado a este pedido.",
        "newItem": "Um item novo será cadastrado: {{name}}.",
        "withItem": "Item: {{name}}"
      },
      "share": {
        "title": "O que o técnico verá",
        "intro": "Nada é compartilhado até você publicar. Escolha abaixo e confira a prévia."
      },
      "progress": "Passo {{current}} de {{total}} · {{name}}"
    },
    "share": {
      "publish": "Publicar e continuar",
      "publishUpdate": "Compartilhar as informações atualizadas",
      "publishTitle": "Escolha o que compartilhar",
      "updateTitle": "Atualizar informações compartilhadas",
      "updateIntro": "Escolha o que os técnicos verão na nova versão.",
      "updateNote": "Os técnicos convidados serão avisados da atualização, e as propostas já enviadas precisarão ser reconfirmadas por eles antes de você escolher uma.",
      "published": "Pedido compartilhado (versão {{number}}).",
      "sendFailed": "Não foi possível enviar. Seu rascunho foi mantido. Tente novamente.",
      "conflict": "Este pedido foi alterado em outro lugar. Recarregue para ver a versão mais recente e publique de novo.",
      "reload": "Recarregar o pedido",
      "notEditable": "Este pedido não aceita mais novas informações compartilhadas."
    },
    "detail": {
      "fields": "Dados do pedido",
      "saved": "Pedido atualizado.",
      "editNote": "As mudanças ficam só com você até serem compartilhadas de novo.",
      "conflict": "Alguém alterou este pedido enquanto você editava. Recarregue a página para ver a versão mais recente.",
      "location": "Bairro e cidade",
      "publish": "Escolher o que compartilhar e publicar",
      "updateShared": "Atualizar informações compartilhadas",
      "unpublishedTitle": "Há alterações não compartilhadas",
      "unpublishedBody": "Os técnicos ainda veem a versão anterior. Ao atualizar as informações compartilhadas, eles são avisados e as propostas precisam ser reconfirmadas.",
      "nextStep": "Próximo passo: crie um link para cada técnico de quem você quer receber resposta.",
      "quotes": {
        "title": "Propostas",
        "compare": "Comparar propostas",
        "empty": "Nenhuma proposta ainda. Os técnicos respondem pelo próprio link."
      },
      "revisions": {
        "title": "Versões compartilhadas",
        "number": "Versão {{number}}",
        "current": "Atual",
        "view": "Ver exatamente o que foi compartilhado",
        "item": "Dados do item",
        "documents_one": "{{count}} documento",
        "documents_other": "{{count}} documentos",
        "records_one": "{{count}} registro de serviço",
        "records_other": "{{count}} registros de serviço",
        "location": "bairro e cidade"
      }
    },
    "invitations": {
      "title": "Técnicos",
      "intro": "Cada técnico recebe um link individual. Você pode revogá-lo quando quiser.",
      "needsPublish": "Publique o pedido primeiro para convidar técnicos.",
      "closed": "Este pedido não aceita novos técnicos.",
      "empty": "Nenhum técnico convidado ainda.",
      "unnamed": "Técnico sem nome",
      "status": {
        "active": "Link ativo",
        "revoked": "Link revogado",
        "expired": "Link expirado"
      },
      "verified": "Identidade verificada",
      "notVerified": "Ainda não verificado",
      "quoteYes": "Proposta recebida",
      "quoteNo": "Sem proposta",
      "expires": "Link válido até",
      "viewed": "Última visualização",
      "notViewed": "Ainda não visualizou",
      "identity": "Identidade verificada",
      "newLink": "Gerar novo link",
      "revoke": "Revogar acesso",
      "revoked": "Acesso revogado.",
      "revokeTitle": "Revogar o acesso de {{name}}?",
      "revokeDescription": "O técnico perde o acesso imediatamente. Arquivos já baixados não podem ser recuperados.",
      "rotateTitle": "Gerar um novo link para {{name}}?",
      "rotateDescription": "O link anterior deixa de funcionar. Envie o novo link ao mesmo técnico.",
      "create": {
        "open": "Criar link para um técnico",
        "title": "Novo link de técnico",
        "description": "O link abre somente o que você escolheu compartilhar.",
        "label": "Nome privado",
        "labelHint": "Só você vê. Por exemplo, “Eletricista do João”.",
        "email": "E-mail do técnico",
        "emailHint": "Se preencher, enviamos o link por e-mail e só esse endereço poderá verificar.",
        "locale": "Idioma do técnico",
        "localeHint": "O técnico pode mudar na página.",
        "days": "Validade (dias)",
        "daysInvalid": "Use um número inteiro de 1 a 60.",
        "submit": "Criar link"
      },
      "link": {
        "title": "Link pronto",
        "description": "Envie você mesmo ao técnico, por exemplo por mensagem. O Lumora não envia automaticamente.",
        "label": "Link do técnico",
        "copy": "Copiar link",
        "copiedShort": "Copiado",
        "copied": "Link copiado.",
        "copyFailed": "Não foi possível copiar. Selecione o link e copie manualmente.",
        "share": "Compartilhar",
        "shareTitle": "Pedido de orçamento",
        "shareText": "Aqui estão as informações para o orçamento:",
        "once": "Este link aparece só agora e não poderá ser mostrado de novo. Se perder, gere um novo link e o antigo deixa de funcionar.",
        "emailed": "Também enviamos este link por e-mail para {{email}}.",
        "done": "Concluir"
      }
    },
    "selection": {
      "quoteSelected": "Proposta selecionada",
      "visitRequested": "Visita solicitada",
      "requestCancelled": "Pedido cancelado",
      "quoteTitle": "Proposta selecionada: {{name}}",
      "visitTitle": "Visita solicitada: {{name}}",
      "on": "Escolhido em {{date}}",
      "by": "por {{name}}",
      "quoteNote": "Você escolheu esta proposta. As condições finais ainda são combinadas com o prestador.",
      "visitNote": "Você pediu uma visita de avaliação. Isso não é aceite de preço final.",
      "disclaimer": "Escolher não é contrato nem pagamento. As condições finais e a execução são combinadas diretamente com o prestador.",
      "seeQuote": "Ver a proposta",
      "switchNote": "Para trabalhar com outro técnico, cancele este pedido e crie um novo. O histórico desta escolha é mantido.",
      "createFromThis": "Criar novo pedido com as mesmas informações"
    },
    "cancel": {
      "title": "Cancelar pedido",
      "description": "Os técnicos são avisados e os links deixam de ser úteis. O histórico é mantido.",
      "descriptionDraft": "Este rascunho será cancelado. Nada foi compartilhado com técnicos.",
      "descriptionSelected": "Um técnico já foi escolhido. Cancelar mantém o histórico e a escolha, avisa o técnico e exige um motivo.",
      "action": "Cancelar pedido",
      "confirmTitle": "Cancelar este pedido?",
      "confirm": "Os técnicos serão avisados. O histórico e as propostas recebidas são mantidos.",
      "confirmSelected": "O técnico escolhido será avisado. O histórico, as propostas e a escolha são mantidos.",
      "reason": "Motivo",
      "reasonRequired": "Informe o motivo: ele é compartilhado com o técnico.",
      "reasonLabel": "Motivo",
      "keep": "Manter o pedido",
      "done": "Pedido cancelado.",
      "cancelledTitle": "Este pedido foi cancelado",
      "history": "O histórico é mantido e os técnicos são avisados."
    }
  },
  "share": {
    "privacy": {
      "title": "O técnico verá apenas as informações selecionadas abaixo.",
      "body": "O endereço completo nunca é compartilhado. Documentos ficam desligados até você escolhê-los."
    },
    "item": {
      "title": "Dados do item",
      "hint": "O nome e a categoria de “{{name}}” são sempre compartilhados. Escolha o restante.",
      "none": "Nenhum item vinculado, então nenhum dado de item é compartilhado.",
      "notInformed": "Não informado",
      "fields": {
        "brand": "Marca",
        "model": "Modelo",
        "serial_number": "Número de série",
        "room": "Ambiente",
        "purchase_date": "Data da compra",
        "warranty_until": "Fim da garantia"
      }
    },
    "location": {
      "title": "Localização",
      "include": "Compartilhar bairro e cidade",
      "empty": "Preencha bairro ou cidade na etapa do problema para poder compartilhá-los.",
      "neverAddress": "O endereço completo nunca é compartilhado."
    },
    "documents": {
      "title": "Documentos",
      "hint": "Escolha até {{max}} documentos que o técnico poderá abrir. Só arquivos prontos aparecem.",
      "sensitive": "Notas fiscais, manuais e fotos de etiqueta podem conter dados pessoais. Ficam desligados até você escolher.",
      "sensitiveKind": {
        "label": "Etiquetas podem conter informações sensíveis",
        "invoice": "Notas fiscais podem conter dados pessoais",
        "receipt": "Recibos podem conter dados pessoais"
      },
      "none": "Nenhum documento pronto para este item.",
      "full": "Você chegou ao limite de {{max}} documentos.",
      "pickMore": "Adicionar documento da casa"
    },
    "records": {
      "title": "Histórico de serviços",
      "hint": "Escolha até {{max}} serviços anteriores que ajudem o técnico.",
      "none": "Nenhum serviço registrado para este item."
    },
    "picker": {
      "title": "Documentos da casa",
      "description": "Escolha arquivos para ficarem disponíveis ao técnico.",
      "none": "Nenhum outro documento pronto.",
      "add_one": "Adicionar {{count}} documento",
      "add_other": "Adicionar {{count}} documentos"
    },
    "preview": {
      "title": "O que o técnico verá",
      "technicianSees": "É exatamente isto que o técnico recebe com as suas escolhas atuais.",
      "loading": "Preparando a prévia…",
      "expiry": "Cada link de técnico tem validade própria e você pode revogá-lo quando quiser."
    },
    "snapshot": {
      "title": "Informações compartilhadas",
      "problem": "Problema",
      "symptoms": "O que está acontecendo",
      "item": "Item",
      "noItem": "Nenhum dado de item foi compartilhado.",
      "where": "Localização e disponibilidade",
      "noLocation": "Localização não compartilhada",
      "availability": "Disponibilidade",
      "history": "Histórico de serviços",
      "documents": "Documentos",
      "source": {
        "resident": "Registrado pelo morador",
        "technician": "Informado pelo prestador"
      }
    }
  },
  "quotes": {
    "title": "Propostas",
    "intro": "Leia as condições de cada proposta antes de escolher. O preço é só uma das diferenças.",
    "orderNote": "As propostas aparecem na ordem em que foram recebidas. O Lumora não faz ranking.",
    "backToRequest": "Voltar ao pedido",
    "empty": {
      "title": "Nenhuma proposta ainda",
      "description": "Quando os técnicos enviarem propostas, elas aparecem aqui para comparação."
    },
    "details": "Cada proposta em detalhe",
    "type": {
      "fixed": "Preço fechado",
      "estimate": "Estimativa",
      "visit_required": "Visita necessária"
    },
    "state": {
      "current": "Atual",
      "needs_reconfirmation": "Precisa reconfirmar",
      "expired": "Vencida",
      "withdrawn": "Retirada",
      "selected": "Selecionada",
      "not_selected": "Não selecionada"
    },
    "why": {
      "needs_reconfirmation": "Esta proposta se baseia em uma versão anterior do pedido. O técnico precisa reconfirmá-la antes de você poder escolhê-la.",
      "expired": "Esta proposta venceu e não pode ser escolhida.",
      "withdrawn": "O técnico retirou esta proposta.",
      "selected": "Esta proposta foi selecionada.",
      "not_selected": "Outra proposta foi selecionada.",
      "request_draft": "O pedido é um rascunho, então ainda não é possível escolher propostas.",
      "request_selected": "Já existe uma proposta selecionada neste pedido.",
      "request_completed": "Este pedido está concluído.",
      "request_cancelled": "Este pedido foi cancelado."
    },
    "version": "Versão {{number}}",
    "basedOn": "baseada na revisão {{number}} do pedido",
    "sentAt": "recebida em {{date}}",
    "price": "Preço",
    "total": {
      "tbd": "Valor a definir",
      "afterVisit": "Valor a definir após a visita.",
      "knownSubtotal": "Subtotal conhecido"
    },
    "scope": "Escopo",
    "exclusions": "O que não está incluído",
    "exclusionsNone": "Nenhuma exclusão informada",
    "notInformed": "Não informado",
    "warranty": "Garantia (declarada pelo técnico)",
    "availability": "Disponibilidade",
    "validUntil": "Válida até",
    "declaredNote": "Garantia, disponibilidade e validade são declaradas pelo técnico.",
    "visitFee": {
      "label": "Taxa de visita",
      "none": "Sem taxa de visita",
      "unknown": "Taxa de visita não informada"
    },
    "lines": {
      "title": "Itens",
      "tbd": "a definir",
      "category": {
        "labor": "Mão de obra",
        "parts": "Peças",
        "other": "Outros"
      }
    },
    "versions": {
      "title_one": "Histórico de versões ({{count}} versão)",
      "title_other": "Histórico de versões ({{count}} versões)",
      "none": "Nenhuma versão anterior."
    },
    "compare": {
      "title": "Comparação",
      "note": "Todos os valores estão em {{currency}}. Diferenças de escopo e exclusões importam tanto quanto o preço.",
      "caption": "Comparação das propostas em {{currency}}",
      "criterion": "Critério",
      "versionAndRevision": "Versão {{version}}, baseada na revisão {{revision}} do pedido",
      "criteria": {
        "type": "Tipo",
        "price": "Preço",
        "basedOn": "Versão",
        "state": "Situação"
      }
    },
    "select": {
      "action": "Escolher a proposta de {{name}}",
      "visitAction": "Solicitar visita de {{name}}",
      "readFirst": "Leia o escopo, as exclusões e os custos acima antes de escolher.",
      "title": "Escolher a proposta de {{name}}?",
      "description": "Você está escolhendo esta proposta. As demais ficam como não selecionadas, sem que uma veja a outra.",
      "visitTitle": "Solicitar a visita de {{name}}?",
      "visitDescription": "Você está pedindo que este técnico visite e avalie. O preço não é final e não está aceito.",
      "acknowledge": "Entendo que as condições finais e a execução são combinadas diretamente com o prestador. Isto não é contrato nem pagamento.",
      "confirm": "Escolher esta proposta",
      "visitConfirm": "Solicitar a visita",
      "done": "Escolha registrada."
    }
  },
  "tech": {
    "footer": "Esta página é privada e foi compartilhada com você para um orçamento. O Lumora não executa consertos nem garante prestadores.",
    "requestFrom": "Pedido de {{name}}",
    "request": "Pedido de orçamento",
    "revision": "Versão {{number}}",
    "sharedOn": "Compartilhado em {{date}}",
    "expiresOn": "Link válido até {{date}}",
    "sharedNote": "Você vê apenas o que o morador escolheu compartilhar.",
    "gate": {
      "title": "Confirme seu e-mail",
      "body": "Este pedido está vinculado a uma identidade verificada. Confirme seu e-mail para abri-lo."
    },
    "invalid": {
      "title": "Link não encontrado",
      "body": "Confira se copiou o link inteiro ou peça um novo ao morador."
    },
    "gone": {
      "invitation_revoked": {
        "title": "Acesso encerrado",
        "body": "O morador encerrou seu acesso a este pedido. Se acha que foi engano, peça um novo link."
      },
      "invitation_expired": {
        "title": "Este link expirou",
        "body": "Peça um novo link ao morador se ainda quiser enviar uma proposta."
      },
      "request_cancelled": {
        "title": "Pedido cancelado",
        "body": "O morador cancelou este pedido. Não precisamos de mais nada de você."
      }
    },
    "respond": {
      "title": "Enviar proposta",
      "body": "Para enviar ou alterar uma proposta, confirme seu e-mail com um código de uso único.",
      "verify": "Confirmar meu e-mail"
    },
    "verify": {
      "why": "Enviamos um código de 6 dígitos para o seu e-mail para confirmar que é você. Não é preciso criar conta.",
      "hintRestricted": "{{hint}}",
      "email": "Seu e-mail",
      "sendCode": "Enviar código",
      "sent": "Enviamos um código de 6 dígitos para {{email}}. Ele vale por 10 minutos.",
      "resent": "Enviamos um novo código.",
      "code": "Código",
      "codeHint": "Seis dígitos.",
      "codeFormat": "Digite os 6 dígitos.",
      "name": "Seu nome",
      "company": "Empresa",
      "confirm": "Confirmar",
      "resend": "Enviar o código de novo",
      "resendIn": "Enviar de novo em {{seconds}} s",
      "waitToRetry": "Aguarde {{seconds}} s para tentar de novo.",
      "changeEmail": "Usar outro e-mail"
    },
    "quote": {
      "title": "Sua proposta",
      "formTitle": "Formulário da proposta",
      "reconfirmTitle": "Reconfirmar sua proposta",
      "send": "Enviar proposta",
      "sendNewVersion": "Enviar nova versão",
      "reconfirm": "Reconfirmar proposta",
      "reconfirmStart": "Revisar e reconfirmar",
      "sendAgain": "Enviar uma nova proposta",
      "newVersion": "Editar e enviar nova versão",
      "sent": "Proposta enviada.",
      "notOpen": "Este pedido não está mais aberto para propostas.",
      "withdraw": "Retirar proposta",
      "withdrawTitle": "Retirar sua proposta?",
      "withdrawDescription": "O morador não poderá mais escolhê-la. Você pode enviar uma nova versão depois, se o pedido ainda estiver aberto.",
      "withdrawnNote": "Você retirou esta proposta. Enviar uma nova versão a deixa disponível de novo.",
      "needsReconfirmTitle": "As informações do pedido mudaram",
      "needsReconfirmBody": "Sua proposta se baseia em uma versão anterior. Confira as informações acima (versão {{number}}) e reconfirme.",
      "outdatedTitle": "As informações do pedido mudaram",
      "outdatedBody": "Confira as informações atualizadas acima, ajuste sua proposta se precisar e envie de novo. Suas respostas continuam aqui.",
      "currencyNote": "Todos os valores estão em {{currency}}, a moeda do pedido.",
      "type": "Tipo de proposta",
      "typeHint": {
        "fixed": "Um preço fechado para o escopo descrito.",
        "estimate": "Um preço aproximado que pode mudar. Marque os itens que ainda não consegue precificar.",
        "visit_required": "Você precisa visitar antes de precificar."
      },
      "scopeHint": "O que você vai fazer, em palavras simples.",
      "exclusionsHint": "O que não está incluído, para evitar surpresas.",
      "lines": {
        "empty": "Nenhum item ainda.",
        "item": "Item {{number}}",
        "category": "Categoria",
        "description": "Descrição",
        "quantity": "Quantidade",
        "quantityInvalid": "Use um número inteiro igual ou maior que 1.",
        "price": "Preço unitário ({{currency}})",
        "unknown": "Preço a definir",
        "lineTotal": "Total do item",
        "add": "Adicionar item",
        "remove": "Remover item {{number}}",
        "removeShort": "Remover",
        "max": "Você chegou ao limite de {{max}} itens.",
        "needOne": "Adicione ao menos um item ou escolha “Visita necessária”.",
        "fix": "Corrija os itens marcados abaixo."
      },
      "fixedUnknown": "Um preço fechado não deveria ter itens a definir. Considere escolher “Estimativa”.",
      "preview": "Prévia do total",
      "previewUnknown": "Pelo menos um item ainda não tem preço, então o total fica a definir.",
      "previewNote": "Mostrado para ajudar você. O Lumora calcula os valores finais ao enviar.",
      "fee": {
        "none": "Sem taxa de visita",
        "known": "Há taxa de visita",
        "unknown": "Há taxa de visita, mas ainda não sei o valor",
        "amount": "Valor da taxa de visita ({{currency}})",
        "unknownNote": "O morador verá que a taxa existe, mas não foi informada."
      },
      "warrantyHint": "Descreva a garantia que você oferece, se houver.",
      "notContract": "Enviar uma proposta não é um contrato. As condições finais são combinadas diretamente com o morador."
    },
    "outcome": {
      "quote_selected": {
        "title": "Sua proposta foi selecionada",
        "body": "O morador vai combinar as condições finais diretamente com você. Isto não é contrato nem pagamento."
      },
      "visit_requested": {
        "title": "O morador solicitou sua visita",
        "body": "É um pedido de visita de avaliação, não o aceite de um preço final."
      },
      "not_selected": {
        "title": "Não selecionada desta vez",
        "body": "O morador escolheu outra opção. Obrigado por responder."
      }
    },
    "service": {
      "title": "Registrar serviço realizado",
      "correctTitle": "Corrigir registro do serviço",
      "intro": "Seu orçamento foi escolhido. Quando o serviço estiver feito, registre aqui para o morador confirmar.",
      "list": "Seus registros de serviço",
      "date": "Data do serviço",
      "description": "O que foi feito",
      "descriptionHint": "Descreva o serviço de forma objetiva.",
      "parts": "Peças usadas",
      "cost": "Valor cobrado",
      "warrantyUntil": "Garantia até",
      "warrantyNotes": "Condições da garantia",
      "notice": "O morador vai conferir e confirmar. Até lá, o registro fica como “aguardando confirmação”.",
      "send": "Enviar para confirmação",
      "resend": "Reenviar corrigido",
      "sent": "Enviado para confirmação do morador.",
      "pendingNote": "O morador ainda vai confirmar este registro.",
      "confirmedNote": "O morador confirmou este registro.",
      "correctionAsked": "O morador pediu uma correção.",
      "reason": "Motivo: {{reason}}",
      "correct": "Corrigir registro",
      "stale": "Este registro já mudou. Recarregue a página para ver a versão atual.",
      "status": {
        "pending_confirmation": "Aguardando confirmação",
        "correction_requested": "Correção solicitada",
        "confirmed": "Confirmado pelo morador"
      }
    }
  },
  "notifications": {
    "title": "Notificações",
    "bell": "Notificações",
    "bellUnread_one": "Notificações, {{count}} não lida",
    "bellUnread_other": "Notificações, {{count}} não lidas",
    "unreadCount_one": "{{formatted}} não lida",
    "unreadCount_other": "{{formatted}} não lidas",
    "allRead": "Tudo lido.",
    "markAll": "Marcar todas como lidas",
    "onlyUnread": "Mostrar só as não lidas",
    "unread": "Não lida",
    "markReadHint": "Abra para marcar como lida.",
    "empty": {
      "title": "Nenhuma notificação ainda",
      "description": "Avisos de orçamentos, serviços e lembretes aparecem aqui."
    },
    "emptyUnread": {
      "title": "Nada por ler",
      "description": "Você está em dia."
    },
    "fallback": {
      "someone": "Alguém"
    },
    "prefs": {
      "title": "Notificações",
      "description": "Escolha, para cada tipo de aviso, se quer recebê-lo no app e por e-mail.",
      "inApp": "No app",
      "email": "Por e-mail",
      "types": {
        "quote_received": "Orçamento recebido",
        "quote_updated": "Orçamento atualizado",
        "request_selected_confirmation": "Escolha de orçamento",
        "request_cancelled": "Pedido cancelado",
        "service_confirmation_needed": "Serviço aguardando confirmação",
        "service_record_corrected": "Serviço corrigido pelo prestador",
        "reminder_due": "Lembrete no prazo",
        "warranty_expiring": "Garantia perto do fim",
        "export_ready": "Exportação pronta",
        "ownership_transfer_requested": "Pedido de transferência",
        "member_joined": "Novo membro",
        "extraction_budget_warning": "Limite de leitura de documentos"
      }
    },
    "types": {
      "unknown": {
        "title": "Novidade na casa",
        "body": "Abra para ver."
      },
      "quote_received": {
        "title": "Orçamento recebido",
        "body": "{{technician}} enviou um orçamento para “{{request_title}}”."
      },
      "quote_updated": {
        "title": "Orçamento atualizado",
        "body": "{{technician}} atualizou o orçamento de “{{request_title}}”."
      },
      "request_selected_confirmation": {
        "title": "Escolha registrada",
        "body_quote_selected": "{{selected_by}} escolheu um orçamento em “{{request_title}}”.",
        "body_visit_requested": "{{selected_by}} pediu uma visita em “{{request_title}}”."
      },
      "request_cancelled": {
        "title": "Pedido cancelado",
        "body": "{{cancelled_by}} cancelou o pedido “{{request_title}}”."
      },
      "service_confirmation_needed": {
        "title": "Serviço aguarda confirmação",
        "body": "{{provider}} informou o serviço do pedido “{{request_title}}”. Confirme ou peça correção."
      },
      "service_record_corrected": {
        "title": "Serviço corrigido",
        "body": "{{provider}} corrigiu o serviço de “{{request_title}}”. Revise novamente."
      },
      "reminder_due": {
        "title": "Lembrete",
        "body": "“{{title}}” vence em {{due_on}}."
      },
      "warranty_expiring": {
        "title": "Garantia perto do fim",
        "body": "A garantia de {{asset_name}} informada por você termina em {{warranty_until}}."
      },
      "export_ready": {
        "title": "Exportação pronta",
        "body": "A exportação de {{household_name}} está pronta para baixar por 24 horas."
      },
      "ownership_transfer_requested": {
        "title": "Pedido de transferência",
        "body": "{{from}} quer transferir a propriedade de {{household_name}} para você."
      },
      "member_joined": {
        "title": "Novo membro",
        "body": "{{member}} entrou em {{household_name}}."
      },
      "extraction_budget_warning": {
        "title": "Leitura de documentos quase no limite",
        "body": "{{household_name}} usou {{used}} de {{limit}} leituras do mês."
      }
    },
    "filterAll": "Todas",
    "filterUnread": "Não lidas"
  },
  "reminders": {
    "title": "Lembretes",
    "subtitle": "Datas que você quer lembrar. Nada é concluído sozinho: você marca como feito.",
    "new": "Novo lembrete",
    "state": {
      "upcoming": "Em breve",
      "due_today": "Vence hoje",
      "overdue": "Atrasado",
      "finished": "Concluído"
    },
    "source": {
      "warranty": "Garantia"
    },
    "warrantyReason": "Aviso automático antes do fim da garantia que você informou.",
    "recurrence": {
      "once": "Uma vez",
      "days_one": "A cada {{count}} dia",
      "days_other": "A cada {{count}} dias",
      "months_one": "A cada {{count}} mês",
      "months_other": "A cada {{count}} meses"
    },
    "when": {
      "today": "hoje",
      "in_one": "em {{count}} dia",
      "in_other": "em {{count}} dias",
      "late_one": "{{count}} dia de atraso",
      "late_other": "{{count}} dias de atraso"
    },
    "finishedOn": "Concluído em {{date}}",
    "lastDone": "Última vez feito em {{date}}",
    "count_one": "{{formatted}} lembrete",
    "count_other": "{{formatted}} lembretes",
    "filters": {
      "status": "Situação",
      "statuses": {
        "active": "Ativos",
        "overdue": "Atrasados",
        "upcoming": "Próximos",
        "finished": "Concluídos"
      },
      "asset": "Equipamento ou área",
      "assetAll": "Todos os itens",
      "assetSelected": "Item selecionado"
    },
    "empty": {
      "title": "Nenhum lembrete ainda",
      "description": "Crie um lembrete para uma troca de filtro, uma revisão ou qualquer data que importe. Você escolhe a frequência."
    },
    "noResults": {
      "title": "Nenhum lembrete com estes filtros",
      "description": "Tente outra situação ou outro item.",
      "clear": "Limpar filtros"
    },
    "complete": {
      "action": "Marcar como feito",
      "title": "Marcar “{{title}}” como feito",
      "description": "Diga quando foi feito. Isso fica registrado.",
      "date": "Data em que foi feito",
      "note": "Observação",
      "confirm": "Marcar como feito",
      "nextOnce": "Este lembrete é de uma vez só: depois de marcado, ele fica concluído.",
      "nextInterval": "A próxima data será {{date}}, contada a partir de {{from}}.",
      "nextIntervalUnknown": "A próxima data será calculada a partir da data informada.",
      "done": "Lembrete marcado como feito.",
      "conflict": "Este lembrete mudou ou já foi concluído. Feche e confira a lista atualizada."
    },
    "form": {
      "editCrumb": "Editar",
      "editTitle": "Editar lembrete",
      "titleLabel": "O que lembrar?",
      "titleHint": "Por exemplo “Trocar o filtro do purificador”.",
      "asset": "Equipamento ou área",
      "noAsset": "Nenhum item",
      "firstDate": "Primeira data",
      "nextDate": "Próxima data",
      "dateHint": "Dia no calendário da casa. Hoje é {{today}}.",
      "repeat": "Repetir?",
      "once": "Só uma vez",
      "interval": "Repetir em intervalos que eu escolher",
      "chooseRepeat": "Escolha uma opção.",
      "every": "A cada quanto?",
      "everyInvalid": "Use um número inteiro de 1 a 120.",
      "unit": "Unidade",
      "unitChoose": "Escolha a unidade",
      "units": {
        "days": "dias",
        "months": "meses"
      },
      "intervalNote": "Depois de marcar como feito, a próxima data conta a partir do dia em que foi feito.",
      "notes": "Observações",
      "create": "Criar lembrete",
      "saved": "Lembrete salvo.",
      "conflict": "Este lembrete foi alterado por outra pessoa. Recarregue a página e tente de novo.",
      "warrantyManaged": "Este lembrete de garantia é mantido a partir do equipamento. Para mudar, edite a garantia do item.",
      "openAsset": "Editar o equipamento"
    },
    "delete": {
      "title": "Excluir lembrete",
      "description": "O lembrete deixa de avisar. O histórico de serviços do item não muda.",
      "action": "Excluir lembrete",
      "confirmTitle": "Excluir “{{title}}”?",
      "confirm": "Esta ação não pode ser desfeita.",
      "done": "Lembrete excluído."
    }
  }
}
